/* import __COLOCATED_TEMPLATE__ from './panning-toggle.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type Graph from '../../../models/graph-editor/graph';

interface Args {
  graph: Graph;
}

export default class GraphEditorControlsPanningToggleComponent extends Component<Args> {
  @action togglePanningMode(): void {
    this.args.graph.state.inPanningMode = !this.args.graph.state.inPanningMode;
  }
}
